import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { PayrunApprover } from '@xemplo/gp-types';
import { BodyXSmallRegular, LinkUnderline, TextEllipsis } from '@xemplo/style-constants';
import { XemploTable } from '@xemplo/table';

export const PayrunApproversListContainer = styled.div`
  padding: 32px 72px;
`;

export const PayScheduleContainer = styled.div`
  display: flex;
  height: 24px;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
`;

export const PayScheduleNav = styled(Link)`
  cursor: pointer;
  ${BodyXSmallRegular}
  ${TextEllipsis}
  ${LinkUnderline}
`;

export const PayScheduleDetailNav = styled.span`
  background: none;
  border: none;
  cursor: pointer;
  ${BodyXSmallRegular}
  ${TextEllipsis}
  ${LinkUnderline}
`;

export const Table = styled(XemploTable<PayrunApprover>)`
  ${BodyXSmallRegular};
`;
